import IConfig from '../../Display/IConfig';
import IBasicDriver from '../../NativeDevice/IBasicDriver';
import { chooseUrl } from '../../Util/urlEvaluator';
import url from 'url';
import { fetch, FetchFn } from '../../Isomorphic/fetch';

/**
 * @param fetchFn - only for testing purposes
 */
export type GetConfigUrlFn = (fetchFn?: FetchFn) => Promise<string>;

/**
 * Returns function that can resolve valid configuration url.
 * The returned function can re-evaluate configUrls when `invalidateUrl()` was called before, i.e. cache was deleted.
 * @param nativeDriver
 * @param defaultConfig
 * @param fetchFn - only for testing purposes
 */
export function createGetConfigUrl(
	nativeDriver: IBasicDriver,
	defaultConfig: Pick<IConfig, 'configUrls'>,
	fetchFn: FetchFn = fetch,
): GetConfigUrlFn {
	return (fetchFunction = fetchFn) => getConfigurationBaseUrl(nativeDriver, defaultConfig, fetchFunction);
}

export async function getConfigurationBaseUrl(
	nativeDriver: IBasicDriver,
	defaultConfig: Pick<IConfig, 'configUrls'>,
	fetchFn: FetchFn = fetch,
) {
	const overideConfigUri: string | null = await nativeDriver.getConfigurationBaseUrl();
	return overideConfigUri || chooseUrl(defaultConfig.configUrls, fetchFn);
}

export function getConfigurationUrl(baseUrl: string, noSsl: boolean, deviceUid: string): string {
	const configUri = `${baseUrl}/configuration/${deviceUid}`;
	return adjustSsl(configUri, noSsl);
}

export function adjustSsl(uri: string, noSsl: boolean) {
	return noSsl ? getNoSslUrl(uri) : uri;
}

export function getNoSslUrl(uri: string) {
	const parsedConfigUri = url.parse(uri, true);
	parsedConfigUri.protocol = 'http:';
	parsedConfigUri.query.signResponse = '1';
	const signedConfigUri = url.format(parsedConfigUri);

	return signedConfigUri;
}
